import {MIN_COOKIE_TTL_MS} from './ssoCookie.consts';

const COOKIE_REFRESH_BUFFER_MS = 60_000; // 1 minute buffer before TTL

export type ScheduleSsoCookieRefreshParams = {
    onRefresh: () => Promise<void>;
};

/**
 * Schedules a cookie refresh slightly before the minimum cookie TTL expires.
 * Returns a disposer that clears the timer.
 */
export const scheduleSsoCookieRefresh = ({onRefresh}: ScheduleSsoCookieRefreshParams): (() => void) => {
    const timeoutMs = Math.max(0, MIN_COOKIE_TTL_MS - COOKIE_REFRESH_BUFFER_MS);

    const timeoutId = window.setTimeout(async () => {
        try {
            await onRefresh();
        } catch {
            // Keep callback resilient
        }
    }, timeoutMs);

    return () => window.clearTimeout(timeoutId);
};
